import { rem } from 'polished'
import styled from 'styled-components'

import { ImporterUploaderContentStyled } from './ImporterUploaderContentStyled'

export const ImporterUploaderContainerStyled = styled.div`
  font-size: ${rem(16)};

  display: flex;
  justify-content: center;

  ${ImporterUploaderContentStyled} {
    height: 100%;
  }
`
